export const GET_POLICY_DETAILS_TRACK = "GET_POLICY_DETAILS_TRACK";
export const STATUS_OF_APPLICATION = 'STATUS_OF_APPLICATION';
export const SET_UPLOAD_FLOW = 'SET_UPLOAD_FLOW';
export const TRANSACTION_ENTRY = 'TRANSACTION_ENTRY';
export const SET_BULLET_POINTS = 'SET_BULLET_POINTS';
export const SET_CODE_STATUS = 'SET_CODE_STATUS';
export const SET_STATUS_FLAG_PDF_DETAILS = 'SET_STATUS_FLAG_PDF_DETAILS';
export const RESET_ACCEPT_OFFER_PDF_DETAILS = 'RESET_ACCEPT_OFFER_PDF_DETAILS';
export const SET_APP_SOURCE = 'SET_APP_SOURCE';
export const SET_BEARER_TYPE = 'SET_BEARER_TYPE';
